import React, { useEffect, useState } from 'react';
import api, { unwrap } from '../utils/api';

export default function Songs() {
  const [songs, setSongs] = useState([]);
  const [file, setFile] = useState(null);
  const [name, setName] = useState('');

  async function load() {
    const r = await api.get('/files/getSongs');
    setSongs(unwrap(r) || []);
  }
  useEffect(() => { load(); }, []);

  async function upload() {
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    fd.append('name', name || file.name);
    await api.post('/files/SaveSongs', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    setFile(null); setName(''); load();
  }

  async function remove(_id) {
    await api.post('/files/deleteSong', { _id });
    load();
  }

  return (
    <>
      <h1>Songs</h1>
      <div className="card">
        <div className="row">
          <input type="file" accept="audio/*" onChange={e => setFile(e.target.files[0])} />
          <input placeholder="Name" value={name} onChange={e => setName(e.target.value)} />
          <button className="btn" onClick={upload} disabled={!file}>Upload</button>
        </div>
      </div>
      <div className="card">
        <table className="table">
          <thead><tr><th>Name</th><th>Preview</th><th></th></tr></thead>
          <tbody>
            {songs.map(s => (
              <tr key={s._id}>
                <td>{s.name}</td>
                <td>{s.path ? <audio controls src={s.path} style={{ height: 30 }} /> : '—'}</td>
                <td><button className="btn small danger" onClick={() => remove(s._id)}>Del</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
